import type { SVGProps } from 'react';

export function CitrusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.871 2.386c.391.39.386 1.02.04 1.452a9.001 9.001 0 0 0 12.65 12.65c.432-.345 1.062-.35 1.453.04l.707.707c.39.39.393 1.028-.029 1.384A12 12 0 0 1 5.78 1.708c.357-.422.994-.42 1.384-.029z" />
      <path d="M9.697 13.996c-.408.408-1.08.39-1.402-.09a7.95 7.95 0 0 1-1.222-3.013c-.097-.536.32-1.007.862-1.048l3.71-.286c.926-.07 1.44 1.048.784 1.705zM14.555 16.464c-.042.543-.513.96-1.05.862a7.95 7.95 0 0 1-3.012-1.221c-.479-.322-.497-.994-.09-1.402l2.733-2.732c.656-.656 1.775-.142 1.704.784zM8.115 8.827c-.608.047-1.12-.459-.992-1.055A7.95 7.95 0 0 1 8.624 4.55c.34-.436.978-.432 1.369-.042l2.34 2.34a1 1 0 0 1-.63 1.705zM19.892 14.407c.39.39.394 1.03-.042 1.369a7.95 7.95 0 0 1-3.224 1.5c-.595.128-1.1-.384-1.054-.992l.276-3.587a1 1 0 0 1 1.704-.63zM16.5 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    </svg>
  );
}
